// actionTypes.js
export const SET_CURRENT_PAGE_SUIVI = 'SET_CURRENT_PAGE_SUIVI';
export const SET_VALUE_SUIVI = 'SET_VALUE_SUIVI';
export const SET_SORT_FIELD_SUIVI = 'SET_SORT_FIELD_SUIVI';
export const SET_ORDER_SUIVI = 'SET_ORDER_SUIVI';
export const SET_STATUT_SUIVI = 'SET_STATUT_SUIVI';
